module.exports = __webpack_public_path__ + "static/media/investor-transaction.334792ef.svg";